import { Link } from "react-router-dom";
import { ArrowRight, Image } from "lucide-react";
import { Button } from "@/components/ui/button";
import { WALL_PRINTING_PATH } from "@/data/wallPrinting";

export default function HomeWallPrinting() {
  return <section className="bg-background"><div className="max-w-[1400px] mx-auto px-4 sm:px-6 pb-12 md:pb-16">
    <article className="max-w-xl border border-border rounded-lg p-6 sm:p-8">
      <Image className="h-7 w-7 text-clay" strokeWidth={1.25} aria-hidden="true" />
      <h2 className="font-heading text-2xl mt-4">Wall Printing &amp; Murals</h2>
      <p className="text-muted-foreground text-sm leading-relaxed mt-3">Custom artwork, business logos and feature walls, printed directly onto suitable surfaces. Preparation and background painting available.</p>
      <Button asChild variant="outline" className="mt-5 !tracking-normal whitespace-normal h-auto min-h-12"><Link to={WALL_PRINTING_PATH}>Explore Wall Printing<ArrowRight className="h-4 w-4 ml-2 shrink-0" aria-hidden="true" /></Link></Button>
    </article>
  </div></section>;
}